import { render } from "./MessageComponent.vue?vue&type=template&id=9a8ef348&scoped=true"
import script from "./MessageComponent.vue?vue&type=script&lang=js"
export * from "./MessageComponent.vue?vue&type=script&lang=js"

import "./MessageComponent.vue?vue&type=style&index=0&id=9a8ef348&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a8ef348"]])

export default __exports__